import { ReserveInfo, serviceType } from '@/commonTypes';
import styles from './styles.module.css';

// const services = [
//   {
//     title: 'تعویض روغن و فیلتر',
//     duration: '۳۰ دقیقه',
//     price: '۴۵۰,۰۰۰',
//     id: 1,
//   },
//   {
//     title: 'دیاگ کامل خودرو',
//     duration: '۴۵ دقیقه',
//     price: '۳۵۰,۰۰۰',
//     id: 2,
//   },
//   {
//     title: 'تعویض لنت ترمز (دستمزد)',
//     duration: '۱ ساعت',
//     price: '۶۰۰,۰۰۰',
//     id: 3,
//   },
// ];

export default function ServiceList({
  services,
  active,
  onClick,
  info,
}: {
  services?: serviceType[];
  active?: string | number;
  onClick: (x: serviceType) => void;
  info?: ReserveInfo;
}) {
  return (
    <div className={styles.container}>
      {services?.map((service) => (
        <label
          key={service.title}
          className={`${styles.card} ${active == service?.id ? styles.activeCard : ''}`}
          onClick={() => onClick(service)}
        >
          <span className={`${styles.radio} ${active == service?.id ? styles.activeRadio : ''}`}>
            {active == service?.id && <span className={styles.radioDot} />}
          </span>

          <div className={styles.content}>
            <div className={styles.title}>{service.title}</div>

            <div className={styles.duration}>
              <span className={styles.clock}>◷</span>
              مدت تقریبی: {service?.duration}
            </div>
          </div>

          <div className={styles.priceWrapper}>
            <div className={styles.price}>{service?.price}</div>
            <div className={styles.currency}>تومان</div>
          </div>
        </label>
      ))}
      {info?.error?.service && info?.messages?.service && (
        <p className={`inputErrorText`}>{info?.messages.service}</p>
      )}
    </div>
  );
}
